import ReviewBookingSummary from './ReviewBookingSummary';

export default ReviewBookingSummary;
